export default __webpack_public_path__ + "static/fonts/DomaineSansDisplay-Regular.060a47b.woff";